import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import usePut from "../../../services/hooks/usePut";
import { Input, SelectInput } from "../../../shared/ReusableComponents";
import DialogBox from "../../../shared/ReusableComponents/DialogBox";
import { apiEndpoints } from "../../../shared/constants/api-constant";
import {
  ManageSelectValue,
  RoleDropdownList,
} from "../../../shared/constants/enums";
import { manageRolePopupField } from "../../../shared/constants/form.model";
import { hideLoader } from "../../../store/currentPreferencesSlice";

function GridEditPopup({ row, isOpen, type, cohortList, onClose }: any) {
  const [fields, setFields] = useState(manageRolePopupField);
  const [formData, setFormData] = useState<any>({
    code: row?.code,
    id: row?.id,
    roleId: row?.roleId,
    cohortId: row?.cohortId,
    statusId: row?.statusId,
  });
  const { putService, data: putRes, loading: putLoading } = usePut();
  const dispatch = useDispatch();

  const handleSubmit = () => {
    const message = `${formData.code} user details have been Successfully Updated.`;
    const payload = { ...formData };
    delete payload["code"];
    if (type === ManageSelectValue.STAFF) {
      delete payload["cohortId"];
    }
    putService(apiEndpoints.USER, payload, message);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: string
  ) => {
    setFormData((prevData: any) => ({
      ...prevData,
      [field]: e.target.value,
    }));
  };

  useEffect(() => {
    if (type === ManageSelectValue.STAFF) {
      let updatedFields = manageRolePopupField.map((col: any) => {
        if (col.key === "roleId") {
          return {
            ...col,
            options: [RoleDropdownList[0], RoleDropdownList[1]],
          };
        }
        return col;
      });
      updatedFields = updatedFields.filter(
        (col: any) => col.key !== "cohortId"
      );
      setFields(updatedFields);
    } else {
      const updatedFields = manageRolePopupField.map((col: any) => {
        if (col.key === "cohortId") {
          return {
            ...col,
            options: cohortList.map((cohort: any) => ({
              value: cohort.id,
              name: cohort.cohortName,
            })),
          };
        }
        if (col.key === "roleId") {
          return {
            ...col,
            options: [RoleDropdownList[2], RoleDropdownList[3]],
          };
        }
        return col;
      });
      setFields(updatedFields);
    }
  }, [type]);

  useEffect(() => {
    !putLoading && dispatch(hideLoader());
    if (putRes === 200) onClose(true);
  }, [putLoading, putRes]);

  return (
    <React.Fragment>
      <DialogBox
        open={isOpen}
        title="Edit Role and Permission "
        buttons={{
          isShowBtns: true,
          primary: "Update",
          secondary: "Cancel",
        }}
        handleSubmit={handleSubmit}
        width={type === ManageSelectValue.STAFF ? "md" : "lg"}
        fullWidth={true}
        btnClass="dialogActions"
        onClose={(e) => onClose(false)}
        minHeight="auto"
      >
        <Grid container spacing={2}>
          {fields.map((field, index) =>
            field.type === "text" ? (
              <Grid key={index} size={type === ManageSelectValue.STAFF ? 4 : 3}>
                <Input
                  name={field.key}
                  label={field.label}
                  value={formData[field.key]}
                  onChange={(e: any) => handleChange(e, field.key)}
                  required={field.required}
                  disabled={field.disable}
                  size="small"
                />
              </Grid>
            ) : field.type === "select" ? (
              <Grid key={index} size={type === ManageSelectValue.STAFF ? 4 : 3}>
                <SelectInput
                  name={field.key}
                  label={field.label}
                  value={formData[field.key]}
                  onChange={(e: any) => handleChange(e, field.key)}
                  required={field.required}
                  size="small"
                  options={field.options}
                  isValueId={true}
                />
              </Grid>
            ) : null
          )}
        </Grid>
      </DialogBox>
    </React.Fragment>
  );
}

export default GridEditPopup;
